module.exports = __webpack_public_path__ + "static/media/Rolling Wadi.3ceeefb7.jpg";